import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "form", "input" ]

  show() {
    this.formTarget.classList.remove("hidden")
    this.inputTarget.focus()
  }

  hide() {
    this.formTarget.classList.add("hidden")
    this.inputTarget.value = ""
  }
}
